import React from 'react';
import BotaoContato from '../../components/BotaoContato';
import styles from '../NossasSolucoes.module.css';
import { columnClasses } from './../../sharedProperties';

function CloudServerParte3() {
    return (
        <div className="container" style={{ margin: "0px", maxWidth: "100%" }} >
            <div className="row" >
                <div className={`${columnClasses.colDesk1Mob2} ${styles.nossasSolucoes}`} >
                    <img src="/fundoCloudServer/cloudServer_fundo_parte3_esquerda.png" alt="" className={`${styles.imagem}`} />
                </div>
                <div className={`${columnClasses.colDesk2Mob1} ${styles.nossasSolucoes}`}
                    style={{ background: `url("/fundoCloudServer/cloudServer_fundo_parte3_direita.png")` }}>
                    <div className={`d-flex flex-column justify-content-center ${styles.nossasSolucoes} ${styles.sobreNosTexto}`}>
                        <h1>DESEMPENHO</h1>
                        <h1>PERSONALIZADO</h1>
                        <p>
                            Desfrute dos benefícios de servidores dedicados em Manaus-AM, garantindo <span >baixa latência, hiperconvergência e armazenamento SSD</span> de última geração.
                            <br />
                            Com <span>processadores Xeon</span> e sistemas operacionais <span>Windows ou Linux</span>, você tem o poder de personalizar sua infraestrutura de acordo com suas demandas.
                        </p>
                        <BotaoContato text="OBTER SOLUÇÃO" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CloudServerParte3;